import React, { Component, RefObject, SyntheticEvent } from 'react';
import { onClickOutside } from 'components/common/onClickOutside';
import CopyToClipboard from 'react-copy-to-clipboard';
import intl from 'react-intl-universal';

interface Props {
  // A RefObject rather than the wider Ref, because setClickOutsideRef below reads .current
  // from it — react-onclickoutside needs the node, and a callback ref cannot supply one.
  reference: RefObject<HTMLUListElement | null>;
  hideMenu(): void;
}

class RightClickMenuComponent extends Component<Props> {

  public rightClickMenu = (e: SyntheticEvent) => {
    e.stopPropagation();
  }

  public handleClickOutside = () => {
    this.props.hideMenu();
  }

  public closeMenu = () => {
    this.props.hideMenu();
  }

  public render() {
    return (
      <ul className="rightClickMenu" ref={this.props.reference} onClick={this.rightClickMenu}>
        <CopyToClipboard text={`${process.env.REACT_APP_AUTH_URL}/dataporten/auth`}>
          <li id="l1" onClick={this.closeMenu}>
            {intl.get('login_page.Copy url')}
          </li>
        </CopyToClipboard>
      </ul>
    );
  }

  /**
   * react-onclickoutside resolves the element to test clicks against with findDOMNode
   * unless the instance exposes this. React 19 removes findDOMNode, so every wrapped
   * component here returns its own root node instead.
   */
  public setClickOutsideRef = () => this.props.reference.current;
}

export const RightClickMenu = onClickOutside(RightClickMenuComponent);
